/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { TQLogLevel } from "../../public/TQTypes";

export class TQLogger {
    private _defaultLogLevel = TQLogLevel.ERROR; // error print

    public get defaultLogLevel() {
        return this._defaultLogLevel;
    }
    public set defaultLogLevel(value) {
        this._defaultLogLevel = value;
    }

    public log(msgLevel: TQLogLevel, message: any, ...optionalParams: any[]) {
        if (msgLevel >= this._defaultLogLevel) {
            switch (msgLevel) {
                case TQLogLevel.TRACE:
                    {
                        console.trace(message);
                    }
                    break;

                case TQLogLevel.DEBUG:
                    {
                        console.debug(message);
                    }
                    break;

                case TQLogLevel.INFO:
                    {
                        console.info(message);
                    }
                    break;

                case TQLogLevel.WARN:
                    {
                        console.warn(message);
                    }
                    break;

                case TQLogLevel.ERROR:
                    {
                        console.error(message);
                    }
                    break;

                case TQLogLevel.NONE:
                    {
                        // ...
                    }
                    break;
            }
        }
    }

    public async logMessage(messageLevel: TQLogLevel, message: any, ...optionalParams: any[]): Promise<void> {
        this.log(messageLevel, message, optionalParams);
    }

    public async logDefault(message: any, ...optionalParams: any[]): Promise<void> {
        this.log(this._defaultLogLevel, message, optionalParams);
    }
}
